import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { EconomyService, ActivityStatusItem } from '../../../services/economy.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-deviation',
  templateUrl: './deviation.component.html',
  styleUrls: ['./deviation.component.css']
})
export class DeviationComponent implements OnInit {
    argType;

    argValue;

    public custactNoDeviation;

    public edit?: Edit;

    public selectListOnlyDeviations: OnlyDeviationItem[] = [];

    public selectListDeviationTypes: DeviationTypeItem[] = [];

    public selectListOrderLines: OrderLineItem[] = [];

    public selectListActivityStatuses: ActivityStatusItem[] = [];

    public saving = false;

    public deleting = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService, private economy: EconomyService) {
        this.argType = this.stateService.getStateParams()['argtype'];
        this.argValue = this.stateService.getStateParams()['argvalue'];
        this.custactNoDeviation = this.stateService.getStateParams()['custact_no_deviation'];
    }

    private async loadEdit() {
        if (!!this.argType && !!this.argValue && !!this.custactNoDeviation) {
            this.edit = (await this.datatask.Post(319, {
                argtype: this.argType,
                argvalue: this.argValue,
                custact_no_deviation: this.custactNoDeviation
            }))[0];
        }
    }

    private async loadOnlyDeviations() {
        this.selectListOnlyDeviations = await this.datatask.Post(1134);
    }

    private async loadDeviationTypes() {
        if (!this.edit) return;

        if (this.edit.isnew === '1') {
            return this.selectListDeviationTypes = await this.datatask.Post(43, {
                isactive: '1',
                activitytype_no: this.edit.activitytype_no
            });
        } else if (this.edit.isnew === '0') {
            return this.selectListDeviationTypes = await this.datatask.Post(43, {
                isactive: 'ALL',
                activitytype_no: this.edit.activitytype_no
            });
        }
    }

    private async loadOrderLines() {
        if (!this.edit) return;

        return this.selectListOrderLines = await this.datatask.Post(470, {
            argtype: this.edit.argtype,
            argvalue: this.edit.argvalue,
            custact_no_deviation: this.edit.custact_no_deviation
        });
    }

    private async loadActivityStatuses() {
        if (!this.edit) return;

        return this.selectListActivityStatuses = await this.economy.getActivityStatuses({ activitytype_no: this.edit.activitytype_no });
    }

    private async saveDeviation() {
        await this.datatask.Post(152, this.edit);
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(152, this.edit))[0];

                if (response?.ws_result !== '1') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.ws_result_message
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    public async deleteValues() {
        if (!!this.edit) {
            try {
                this.deleting = true;

                const deleteConfirmed = await this.modal.openConfirmDialog({
                    title: 'confirm_title',
                    translateMessage: true,
                    message: 'confirm_message',
                    type: 'danger'
                });

                if (deleteConfirmed) {
                    await this.datatask.Post(136, { custact_no: this.edit.custact_no_deviation });

                    this.stateService.back();
                }
            } finally {
                this.deleting = false;
            }
        }
    }

    public async goToFunc(state: any) {
        if (!this.edit) return;

        switch (state) {
            case 'selectreport':
                const response = (await this.datatask.Post(152, this.edit))[0];

                if (response?.ws_result !== '1') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.ws_result_message
                    });
                } else {
                    this.stateService?.go('selectreport', {
                        webpage_name: this.stateService?.getCurrentName(),
                        argtype: 'custact_no',
                        argvalue: this.edit?.custact_no
                    });
                }

                break;
            default:
                break;
        }
    }

    public onChanged(_: string, id: keyof Edit) {
        if (!this.edit) return;

        switch (id) {
            case 'activitytype_no':
                Promise.all([
                    this.loadDeviationTypes(),
                    this.loadActivityStatuses()
                ]).then(() => {
                    this.saveDeviation();
                    Promise.resolve();
                });

                break;
            case 'deviationtype_keyno':
            case 'orderline_keyno':
            case 'actstatus_keyno':
            case 'delete_rest_quantity':
                this.saveDeviation();
                break;
            default:
                break;
        }
    }

    public onBlur(id: keyof Edit) {
        if (!this.edit) return;

        switch (id) {
            case 'quantity':
            case 'note':
            case 'solution_proposal':
                this.saveDeviation();
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadEdit();
        this.loadOnlyDeviations();
        this.loadDeviationTypes();
        this.loadOrderLines();
        this.loadActivityStatuses();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    custact_no: string;
    note: string;
    deviationtype_keyno: string;
    nbr_of_pictures: string;
    reg_datetime: string;
    reg_of_username: string;
    show_deletebutton: string;
    nbr_of_checklistdata: string;
    prod_id: string;
    prod_name: string;
    orderline_keyno: string;
    order_internal_no: string;
    isnew: string;
    activitytype_no: string;
    nbr_of_documents: string;
    show_button_documents: string;
    show_setting: string;
    show_orderline_keyno: string;
    solution_proposal: string;
    quantity: string;
    show_solution_proposal: string;
    show_quantity: string;
    actstatus_keyno: string;
    show_actstatus: string;
    argtype: string;
    argvalue: string;
    custact_no_deviation: string;
    show_delete_rest_quantity: string;
    delete_rest_quantity: string;
}

interface OnlyDeviationItem {
    activitytype_no: string;
    activitytype_name: string;
    orderby: number;
    item_id: string;
    item_name: string;
    item_path: string;
    item_state: string;
    item_parms: string;
    item_glyphicon: string;
    item_glyphicon_color: string;
}

interface DeviationTypeItem {
    deviationtype_keyno: string;
    deviationtype_name: string;
    item_id: string;
    item_name: string;
    item_state: string;
    item_parms: string;
    item_path: string;
    orderby: number;
    item_glyphicon: string;
    item_glyphicon_color: string;
}

interface OrderLineItem {
    orderline_keyno: string;
    orderline_name: string;
    orderby: number;
    prod_id: string;
    prod_name: string;
}
